import React from 'react';
import { NavLink } from 'react-router-dom';
import ENUMS from '../../enums/index';
import { connect } from 'react-redux';
import ShowForPermission from '../../components/ShowForPermission';
import MessageDetails from './modals/messageDetails';
import generateClassName from '../../utils/generateClassName';
class MessagesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortype: 'desc',
      messageDetailsOpen: false,
      selectedMessageId: null,
      sortedColumn: ''
    };
  }
  renderStatus = status => {
    switch (ENUMS.BANK_STATUS.list.filter(enum_status => enum_status.value === status)[0].value) {
      case 'PENDING':
        return 'badge-warning';
      case 'ERROR':
        return 'badge-danger';
      case 'TRANSFERRING' | 'CANCEL_BY_CUSTOMER' | 'TIMEOUT':
        return 'badge-info';
      case 'PAID':
        return 'badge-success';
      default:
        break;
    }
  };
  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };
  closeMessageModal = () => {
    this.setState(() => ({
      messageDetailsOpen: false
    }));
  };

  displayMessageDetailsModal = id => {
    let { messagesList = [] } = this.props;
    let selectedMessageId = messagesList.filter(message => message.id == id)[0].id;
    this.setState({ messageDetailsOpen: true, selectedMessageId });
  };
  render() {
    let { messagesList = [], pageNumber, pageSize, sortType } = this.props;
    return (
      <>
        <table className="table table-hover table-light table-striped table-ellipsis">
          <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th onClick={() => this.sortTable('creator')} className="text-center pointer">
                <i
                  name="creator"
                  className={generateClassName('creator', this.state.sortedColumn, sortType)}
                />
                {locales('tables.creator')}
              </th>
              <th onClick={() => this.sortTable('title')} className="text-center pointer">
                <i name="title" className={generateClassName('title', this.state.sortedColumn, sortType)} />
                {locales('tables.title')}
              </th>
              <th onClick={() => this.sortTable('body')} className="text-center pointer">
                <i name="body" className={generateClassName('body', this.state.sortedColumn, sortType)} />
                {locales('tables.body')}
              </th>
              <th onClick={() => this.sortTable('publishedAt')} className="text-center pointer">
                <i
                  name="publishedAt"
                  className={generateClassName('publishedAt', this.state.sortedColumn, sortType)}
                />
                {locales('tables.publishedAt')}
              </th>
              <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
                <i
                  name="createdAt"
                  className={generateClassName('createdAt', this.state.sortedColumn, sortType)}
                />
                {locales('tables.createdAt')}
              </th>
              <th onClick={() => this.sortTable('publisher')} className="text-center pointer">
                <i
                  name="publisher"
                  className={generateClassName('publisher', this.state.sortedColumn, sortType)}
                />
                {locales('tables.publisher')}
              </th>
              <th onClick={() => this.sortTable('expiredAtJalaali')} className="text-center pointer">
                <i
                  name="expiredAtJalaali"
                  className={generateClassName('expiredAtJalaali', this.state.sortedColumn, sortType)}
                />
                {locales('tables.expiredAtJalaali')}
              </th>
              <th className="text-center"></th>
              <th className="text-center"></th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {messagesList.length ? (
              messagesList.map((message, index) => (
                <tr key={message.id}>
                  <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                  <td className="text-center">{message.creator}</td>
                  <td className="text-center">{message.title}</td>
                  <td className="text-center">
                    <span className="text-text-truncate">{message.body}</span>
                  </td>
                  <td className="text-center">{message.publishedAt}</td>
                  <td className="text-center">{message.createdAt}</td>
                  <td className="text-center">{message.publisher}</td>
                  <td className="text-center">{message.expiredAtJalaali}</td>
                  <td title={locales('titles.editMessage')}></td>
                  <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_MESSAGE_DETAILS}>
                    <td title={locales('titles.moreDetails')}>
                      <i
                        onClick={() => this.displayMessageDetailsModal(message.id)}
                        className="text-center far fa-info-circle pointer"
                      />
                    </td>
                  </ShowForPermission>
                  <td title={locales('titles.messageReceivers')}>
                    <NavLink
                      to={{
                        pathname: '/message/receivers',
                        title: message.title,
                        messageId: message.id
                      }}
                    >
                      <i className="text-center fal fa-users-class text-success pointer" />
                    </NavLink>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {this.state.messageDetailsOpen && (
          <MessageDetails
            isOpen={this.state.messageDetailsOpen}
            messageId={this.state.selectedMessageId}
            closeModal={this.closeMessageModal}
          />
        )}
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    messagesList: state.messagesReducer.messagesList
  };
};
export default connect(mapStateToProps)(MessagesTable);
